/* eslint-disable no-console */
/* import('axios').AxiosResponse */
/* global axios */
import ApiClient from '../../../../../api/ApiClient';

class WppConnectAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // Helper function to ensure phone number is properly formatted
  formatPhoneNumber(phone) {
    return phone.startsWith('+') ? phone : `+${phone}`;
  }

  /**
   *
   * @param {string} phone - The phone number
   * @param {string} inboxName - The name of the inbox
   * @returns {
   *  AxiosResponse<{
   *    success: boolean,
   *    qrcode?: string
   *  }>
   * }
   */
  getQrCode(phone, inboxName) {
    const formattedPhone = this.formatPhoneNumber(phone);
    const url = this.url + 'common_whatsapp/qrCode';
    return axios.post(url, {
      name: inboxName,
      channel: {
        type: 'common_whatsapp',
        phone_number: formattedPhone,
      },
    });
  }

  /**
   *
   * @param {string} phone - The phone number
   * @param {string} inboxName - The name of the inbox
   * @returns {
   *  AxiosResponse<{
   *    success: boolean,
   *    status: string
   *  }>
   * }
   */
  checkConnectionStatus(phone, inboxName) {
    const formattedPhone = this.formatPhoneNumber(phone);
    const url = this.url + 'common_whatsapp/connStatus';
    return axios.post(url, {
      name: inboxName,
      channel: {
        type: 'common_whatsapp',
        phone_number: formattedPhone,
      },
    });
  }

  /**
   *
   * @param {string} phone - The phone number
   * @param {string} inboxName - The name of the inbox
   * @returns {
   *  AxiosResponse<{
   *    success: boolean,
   *    status: string
   *  }>
   * }
   */
  closeAndClearSession(phone, inboxName) {
    const formattedPhone = this.formatPhoneNumber(phone);
    const url = this.url + 'common_whatsapp/clearSession';
    return axios.post(url, {
      name: inboxName,
      channel: {
        type: 'common_whatsapp',
        phone_number: formattedPhone,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  waitInSeconds(t = 1) {
    return new Promise(resolve =>
      setTimeout(() => {
        resolve();
      }, t * 1000)
    );
  }
}

export default new WppConnectAPI();